import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  subTitleDivider: {
    marginBottom: theme.spacing(1),
  },
  input: {
    margin: theme.spacing(1),
  },
  block: {
    display: "block",
  },
  caption: {
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
  },
  skeletonText: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  centerContent: {
    display: "flex",
    justifyContent: "center",
  },
}));

export default useStyles;
